import { enableProdMode, LOCALE_ID, importProvidersFrom } from '@angular/core';


import { environment } from './environments/environment';
import { AppComponent } from './app/app.component';
import { FormsModule } from '@angular/forms';
import { withInterceptorsFromDi, provideHttpClient } from '@angular/common/http';
import { AppRoutingModule } from './app/app-routing.module';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { registerLocaleData } from '@angular/common';
import localefr from '@angular/common/locales/fr';
import { CartoFormService } from 'app/cartographie/partials/form/carto-form.service';

if (environment.production) {
  enableProdMode();
}

registerLocaleData(localefr);

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(BrowserModule, AppRoutingModule, FormsModule),
    { provide: LOCALE_ID, useValue: 'fr' },
    provideHttpClient(withInterceptorsFromDi()),
    CartoFormService
  ]
});
